import { BaseService } from "@/script/core/service/BaseService";

export class ConfigService extends BaseService {
    public loadValue(code: string): Promise<any> {
        return super.get("/api/sys/config/load/value", { code });
    }
}
